export const OTT_PLATFORMS = [
  { name: 'Prime Video', id: 119, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/1/11/Amazon_Prime_Video_logo.svg' },
  { name: 'Netflix', id: 8, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg' },
  { name: 'Hulu', id: 15, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Hulu_logo_%282018%29.svg' },
  { name: 'Disney+ Hotstar', id: 122, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/1/1e/Disney%2B_Hotstar_logo.svg' },
  { name: 'Disney+', id: 337, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/Disney%2B_logo.svg' },
  { name: 'Paramount+', id: 531, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/4/4e/Paramount%2B_logo.svg' },
  { name: 'Apple TV+', id: 350, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/2/28/Apple_TV_Plus_Logo.svg' },
  { name: 'Max', id: 1899, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/HBO_Max_May_2025_%28Horizontal%29.svg' },
  { name: 'Peacock', id: 386 },
  { name: 'discovery+', id: 520, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/6/61/Discovery_Plus_logo.svg' },
  { name: 'Tubi', id: 73, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/d/db/Tubi_logo.svg' },
  { name: 'Pluto TV', id: 300, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/5/5d/Pluto_TV_logo.svg' },
  { name: 'Rakuten TV', id: 35 },
  { name: 'ZEE5', id: 232 },
  { name: 'Sony LIV', id: 237 },
  { name: 'MUBI', id: 11 },
  { name: 'Crunchyroll', id: 283, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Crunchyroll_2024.svg' },
  { name: 'Sun Nxt', id: 309 },
  { name: 'Viki', id: 160 },
  { name: 'AMC+', id: 528 },
  { name: 'STARZ', id: 318 },
  { name: 'YouTube Premium', id: 188, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/d/dd/YouTube_Premium_logo.svg' },
  { name: 'Shudder', id: 99 },
  { name: 'Curiosity Stream', id: 190 },
  { name: 'Fandor', id: 25 },
  { name: 'MX Player', id: 381 },
  { name: 'aha', id: 1116, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/b/b3/Aha_OTT_Logo.svg' },
  { name: 'Lionsgate Play', id: 273 },
  { name: 'BINGE', id: 385, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Binge_logo.svg' },
  { name: 'Stan', id: 356 },
];

export const PRODUCTION_HOUSES = [
  { name: 'Warner Bros.', id: 174 },
  { name: 'Paramount Pictures', id: 4 },
  { name: 'Walt Disney Pictures', id: 2 },
  { name: 'Universal Pictures', id: 33 },
  { name: '20th Century Studios', id: 25 },
  { name: 'Marvel Studios', id: 420 },
  { name: 'DC Entertainment', id: 9993 },
  { name: 'Blumhouse Productions', id: 3172 },
  { name: 'A24', id: 41077 },
  { name: 'Lionsgate', id: 1632 },
  { name: 'Pixar', id: 3 },
  { name: 'DreamWorks Animation', id: 521 },
  { name: 'Legendary Pictures', id: 923 },
  { name: 'Columbia Pictures', id: 5, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/1/18/Columbia_Pictures_logo_%281975%E2%80%931981%29.svg' },
  { name: 'Illumination', id: 6704 },
  { name: 'New Line Cinema', id: 12 },
  { name: 'StudioCanal', id: 694 },
  { name: 'Focus Features', id: 10146 },
  { name: 'Annapurna Pictures', id: 10342 },
  { name: 'Bad Robot', id: 11461, commonsLogo: 'https://upload.wikimedia.org/wikipedia/commons/b/bf/Bad_Robot_Productions.svg' },
  { name: 'Sony Pictures', id: 34 },
  { name: 'Metro-Goldwyn-Mayer', id: 8411 },
  { name: 'Miramax', id: 53009 },
  { name: 'Skydance Media', id: 82819 },
  { name: 'Plan B Entertainment', id: 81 },
  { name: 'Regency Enterprises', id: 508 },
  { name: 'Village Roadshow Pictures', id: 79 },
  { name: 'Scott Free Productions', id: 1645 },
  { name: 'Working Title Films', id: 10163 },
];

export const getFilter = (type, id) => {
  const filters = type === 'provider' ? OTT_PLATFORMS : PRODUCTION_HOUSES;
  return filters.find((filter) => String(filter.id) === String(id));
};

export const getFilterName = (type, id) => getFilter(type, id)?.name || 'Platform';
